export default "__VITE_ASSET__DTqG6mlp__"